export function formatDate(dateString: string): string {
    const date = new Date(dateString);
    const now = new Date();
  
    const isToday =
      date.getDate() === now.getDate() &&
      date.getMonth() === now.getMonth() &&
      date.getFullYear() === now.getFullYear();
  
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
  
    const isYesterday =
      date.getDate() === yesterday.getDate() &&
      date.getMonth() === yesterday.getMonth() &&
      date.getFullYear() === yesterday.getFullYear();
  
    const hour = String(date.getHours()).padStart(2, '0');
    const minute = String(date.getMinutes()).padStart(2, '0');
    const formattedTime = `${hour}:${minute}`;
  
    if (isToday) return `Hoje às ${formattedTime}`;
    if (isYesterday) return `Ontem às ${formattedTime}`;
  
    const daysOfWeek = [
      'domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'
    ];
  
    const isThisWeek =
      now.getTime() - date.getTime() <= 6 * 24 * 60 * 60 * 1000 &&
      now.getDay() !== date.getDay();
  
    if (isThisWeek) return `${daysOfWeek[date.getDay()]} às ${formattedTime}`;
  
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
  
    return `${day}/${month}/${year} às ${formattedTime}`;
  }
  